<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">异议管理</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>
        
        <div class="table-section">
            <el-table :data="tableData" border style="width: 100%" class="question-table">
                <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="complaintCode" label="问题编码" min-width="150"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" min-width="180"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidSectionName" label="问题标题" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="问题提交时间" width="180" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleViewDetail(scope.row)" class="view-btn">查看</el-button>
                        <el-button type="text" @click="handleAnswer(scope.row)" class="view-btn">回复</el-button>
                    </template>
                </el-table-column>
            </el-table>


            <!-- 分页 -->
            <div class="pagination-container" v-if="tableData.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>

            <ComplainDialog :visible.sync="complainDialogVisible" :project-code="projectCode"
                :bid-section-code="bidSectionCode" :bid-section-name="bidSectionName" :complaint-type="complaintType"
                :edit-data="editData" @save="handleComplainSave" @close="handleComplainClose"
                :file-bind-id="fileGuid" />

            <!-- 详情弹窗 -->
            <el-dialog title="问题详情" :visible.sync="detailDialogVisible" width="800px" :append-to-body="true">
                <div class="detail-content">
                    <!-- 基本信息 -->
                    <div class="detail-section">
                        <h4>基本信息</h4>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>问题编码：</label>
                                    <span>{{ detailData.complaintCode }}</span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="detail-item">
                                    <label>问题标题：</label>
                                    <span>{{ detailData.title }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- 问题内容 -->
                    <div class="detail-section">
                        <h4>问题内容</h4>
                        <div class="content-box">
                            {{ detailData.content }}
                        </div>
                    </div>

                    <!-- 回复内容 -->
                    <div class="detail-section" v-if="detailData.replyContent">
                        <h4>回复内容</h4>
                        <div class="content-box">
                            {{ detailData.replyContent }}
                        </div>
                    </div>

                    <!-- 附件列表 -->
                    <div class="detail-section" v-if="fileListData.length > 0">
                        <h4>相关附件</h4>
                        <el-table :data="fileListData" border style="width: 100%">
                            <el-table-column prop="fileName" label="文件名" min-width="200"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small">{{ scope.row.fileExtension.toUpperCase() }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                                <template slot-scope="scope">
                                    {{ formatFileSize(scope.row.fileSize) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="downloadFile(scope.row)"
                                        class="download-btn">下载</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 回复附件列表 -->
                    <div class="detail-section" v-if="replyFileListData.length > 0">
                        <h4>回复附件</h4>
                        <el-table :data="replyFileListData" border style="width: 100%">
                            <el-table-column prop="fileName" label="文件名" min-width="200"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column prop="fileExtension" label="文件类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="small">{{ scope.row.fileExtension.toUpperCase() }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
                                <template slot-scope="scope">
                                    {{ formatFileSize(scope.row.fileSize) }}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="downloadFile(scope.row)"
                                        class="download-btn">下载</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 回复弹窗 -->
            <el-dialog title="回复投标人问题" :visible.sync="replyDialog.visible" width="600px" :close-on-click-modal="false" :append-to-body="true">
                <el-form :model="replyDialog.form" :rules="replyDialog.rules" ref="replyForm" label-width="120px">
                    <el-form-item label="问题标题:">
                        <div>{{ replyDialog.questionTitle }}</div>
                    </el-form-item>
                    <el-form-item label="问题内容:">
                        <div>{{ replyDialog.questionContent }}</div>
                    </el-form-item>
                    <el-form-item label="答复内容:" prop="replyContent">
                        <el-input type="textarea" v-model="replyDialog.form.replyContent" :rows="4"
                            placeholder="请输入答复内容"></el-input>
                    </el-form-item>
                    <el-form-item label="答复联系人:" prop="replyContact">
                        <el-input v-model="replyDialog.form.replyContact" placeholder="请输入答复联系人"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人手机:" prop="replyPhone">
                        <el-input v-model="replyDialog.form.replyPhone" placeholder="请输入联系人手机号"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleCancelReply">取消</el-button>
                    <el-button type="primary" @click="handleSubmitReply"
                        :loading="replyDialog.submitting">提交</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import ComplainDialog from '@/components/common/complainDialog.vue'
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { getComplainList, getComplainDetail, submitComplainReply } from '@/api/modules/createComplain'
import { getFileList } from '@/api/modules/base'
export default {
    name: 'RaiseAQuestion',
    components: {
        ComplainDialog
    },
    data() {
        return {
            fileGuid: '',
            projectTitle: '',
            sectionInfo: {},
            tableData: [
            ],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            complainDialogVisible: false,
            projectCode: this.$route.query.projectCode,
            bidSectionCode: '',
            bidSectionName: '标段名称',
            complaintType: 'bidOpen',
            editData: {},
            detailDialogVisible: false,
            detailData: {},
            fileListData: [],
            replyFileListData: [],
            // 回复弹窗
            replyDialog: {
                visible: false,
                submitting: false,
                complaintCode: '',
                questionTitle: '',
                questionContent: '',
                form: {
                    replyContent: '',
                    replyContact: '',
                    replyPhone: '',
                    replyFileGuid: ''
                },
                fileList: [],
                rules: {
                    replyContent: [
                        { required: true, message: '请输入答复内容' }
                    ],
                    replyContact: [
                        { required: true, message: '请输入答复联系人' }
                    ],
                    replyPhone: [
                        { required: true, message: '请输入联系人手机号' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
                    ]
                }
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.initFileGuid()
        this.getComplainList()
    },
    methods: {
        // 初始化文件关联标识
        initFileGuid() {
            this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        },
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        //  获取列表
        async getComplainList() {
            let data = {
                complaintType: this.complaintType,
                projectCode: this.projectCode,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                stage: 0
            }
            const res = await getComplainList(this.complaintType, data);
            if (res.code === 200) {
                this.tableData = res.data.records;
                this.total = res.data.total;
            } else {
                this.$message.error(res.msg)
            }
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 添加问题
        handleAddQuestion() {
            this.complainDialogVisible = true;
        },
        // 查看详细信息
        handleViewDetail(row) {
            console.log(row);
            this.getComplainDetail(row)
        },
        //  查看详情
        async getComplainDetail(row) {
            const res = await getComplainDetail(row.complaintType, { complaintCode: row.complaintCode });
            if (res.code === 200) {
                this.detailData = res.data;
                // 获取问题附件
                if (res.data.submitFileGuid) {
                    await this.getFileList(res.data.submitFileGuid, 'submit');
                }
                // 获取回复附件
                if (res.data.replyFileGuid) {
                    await this.getFileList(res.data.replyFileGuid, 'reply');
                }
                // 打开详情弹窗
                this.detailDialogVisible = true;
            }
        },
        //  获取附件列表
        async getFileList(fileGuid, type = 'submit') {
            try {
                const res = await getFileList(fileGuid);
                if (res.code === 200) {
                    if (type === 'submit') {
                        this.fileListData = res.data || [];
                    } else if (type === 'reply') {
                        this.replyFileListData = res.data || [];
                    }
                }
            } catch (error) {
                console.error('获取附件列表失败:', error);
            }
        },
        // 格式化文件大小
        formatFileSize(size) {
            if (size < 1024) {
                return size + ' B';
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(1) + ' KB';
            } else {
                return (size / (1024 * 1024)).toFixed(1) + ' MB';
            }
        },
        // 下载文件
        downloadFile(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank');
            } else {
                this.$message.error('文件链接不存在');
            }
        },
        // 获取状态标签类型
        getStatusType(status) {
            const statusMap = {
                0: 'warning',
                1: 'success',
                2: 'info'
            }
            return statusMap[status] || 'info'
        },
        // 获取状态标签文字
        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                1: '已提交',
                2: '已答复'
            }
            return statusMap[status] || '未知状态'
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.pageNum = 1
            this.getComplainList()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.pageNum = val
            this.getComplainList()
        },
        // 处理投诉保存
        handleComplainSave(formData) {
            this.complainDialogVisible = false
            this.$message.success(formData.status === 0 ? '暂存成功' : '提交成功')
        },

        // 处理投诉弹窗关闭
        handleComplainClose() {
            this.complainDialogVisible = false
            this.getComplainList()
        },

        // 解答按钮点击
        handleAnswer(row) {
            console.log(row);

            // // 如果已回复，提示不能重复回复
            if (row.rawStatus === 2) {
                this.$message.warning('该问题已回复，不能重复回复')
                return
            }

            // 打开回复弹窗
            this.replyDialog.visible = true
            this.replyDialog.complaintCode = row.complaintCode
            this.replyDialog.questionTitle = row.title
            this.replyDialog.questionContent = row.content

            // 重置表单
            this.replyDialog.form = {
                replyContent: '',
                replyContact: '',
                replyPhone: '',
                replyFileGuid: ''
            }
            this.replyDialog.fileList = []

            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.replyForm) {
                    this.$refs.replyForm.clearValidate()
                }
            })
        },
        // 提交回复
        handleSubmitReply() {
            this.$refs.replyForm.validate(async (valid) => {
                if (valid) {
                    this.replyDialog.submitting = true

                    try {
                        const data = {
                            complaintType: this.complaintType,
                            complaintCode: this.replyDialog.complaintCode,
                            replyContent: this.replyDialog.form.replyContent,
                            replyContact: this.replyDialog.form.replyContact,
                            replyPhone: this.replyDialog.form.replyPhone,
                            replyFileGuid: this.replyDialog.form.replyFileGuid
                        }
                        console.log(data);


                        const res = await submitComplainReply(this.complaintType, data)

                        if (res.code === 200) {
                            this.$message.success('回复成功')
                            this.replyDialog.visible = false
                            // 刷新列表
                            this.getComplainList()
                        } else {
                            this.$message.error(res.msg || '回复失败')
                        }
                    } catch (error) {
                        console.error('回复失败:', error)
                        this.$message.error('回复失败，请重试')
                    } finally {
                        this.replyDialog.submitting = false
                    }
                } else {
                    this.$message.warning('请填写完整信息')
                    return false
                }
            })
        },
    },

}
</script>

<style lang="less" scoped>
/* 详情弹窗样式 */
.detail-content {
    .detail-section {
        margin-bottom: 24px;

        h4 {
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
            border-left: 4px solid #409eff;
            padding-left: 12px;
        }

        .detail-item {
            margin-bottom: 8px;

            label {
                font-weight: 500;
                color: #606266;
                margin-right: 8px;
            }

            span {
                color: #333;
            }
        }

        .content-box {
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            padding: 16px;
            color: #333;
            line-height: 1.6;
            min-height: 80px;
            white-space: pre-wrap;
        }
    }

    .el-table {
        .download-btn {
            color: #409eff;

            &:hover {
                color: #66b1ff;
            }
        }
    }
}

.dialog-footer {
    text-align: center;
}
</style>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
    font-size: 15px;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;
}

.question-table {
    .el-table__header {
        background-color: #f5f7fa;
    }

    .el-table__header th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
    }

    .view-btn {
        color: #409EFF;
        font-weight: 500;

        &:hover {
            color: #66b1ff;
        }
    }
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>